$(document).ready(function() {
    const banner = $('.cookie-banner');
    const acceptButton = $('#accept-cookies');
    const rejectButton = $('#reject-cookies');

    const userChoice = localStorage.getItem('cookieConsent');
    if (userChoice === 'accept' || userChoice === 'reject') {
        banner.hide();
    } else {
        banner.show();
    }

    acceptButton.click(function() {
        banner.hide();
        localStorage.setItem('cookieConsent', 'accept');
    });

    rejectButton.click(function() {
        banner.hide();
        localStorage.setItem('cookieConsent', 'reject');
    });
});